import ReconnectingWebSocket from "reconnecting-websocket";
import { appendMessage } from "./actions/chatActions";

export const STATUS_DISCONNECTED = 0;
export const STATUS_CONNECTED = 1;

class WebsocketController {
  constructor() {
    this.status = STATUS_DISCONNECTED;
    this.ws = null;
    this.timer = null;
    this.lastPong = true;
    this.isAuth = false;
    this.subscribers = new Map();
  }

  init(options = {}) {
    this.options = options;
    this.store = options.store;
    this.dispatch = options.store.dispatch;
    this.needAuth = options.newAuth !== undefined ? options.newAuth : true;

    this.ws = new ReconnectingWebSocket(app.config.wsUrl + options.channel, [], {
      minUptime: 100
    });
    this.ws.onopen = e => this.onOpen(e);
    this.ws.onopen = e => this.onOpen(e);
    this.ws.onmessage = e => this.onMessage(JSON.parse(e.data));
  }

  stop() {
    this.ws.close();
    clearInterval(this.timer);
  }

  send(data) {
    this.ws.send(data);
  }

  sub = (channel, fn) => {
    this.subscribers[ channel ] = this.subscribers[ channel ] || [];
    this.subscribers[ channel ].push(fn);
  };

  unsub = (channel, fn) => {
    if (this.subscribers[ channel ]) {
      for (let i = 0; i < this.subscribers[ channel ].length; i++) {
        if (this.subscribers[ channel ][ i ] === fn) {
          this.subscribers[ channel ].splice(i, 1);
          break;
        }
      }
    }
  };

  setStatus = (status) => {
    this.status = status;

    Object.keys(this.subscribers).forEach(channel => {
      this.subscribers[ channel ].forEach(fn => fn({ type: "status", status }));
    });
  };

  ping = () => {
    if (!this.lastPong) {
      this.ws.reconnect();
      clearInterval(this.timer);
      this.setStatus(STATUS_DISCONNECTED);
    }

    this.lastPong = null;
    this.send(JSON.stringify({ "action": "ping" }));
  };

  onMessage = (data) => {
    if (data.type === "pong") {
      this.lastPong = +Date.now();
      return;
    }

    if (data.status === "1") {
      this.isAuth = true;
    }

    if (data.channel === "chat") {
      if (data.type === "new_message") {
        this.dispatch(appendMessage({ ...data.payload }));
      }
    }

    if (this.subscribers[ data.channel ]) {
      this.subscribers[ data.channel ].forEach(fn => fn(data));
    }

    this.options.onMessage && this.options.onMessage();
  };

  onOpen = () => {
    this.timer = setInterval(this.ping, 2000);

    this.setStatus(STATUS_CONNECTED);

    if (this.needAuth) {
      this.isAuth = false;

      this.ws.send(JSON.stringify({ "action": "auth", "uid": app.key_access }));

      // setTimeout(() => {
      //   if (!this.isAuth) {
      //     window.location.reload();
      //   }
      // }, 3000);
    }

    this.options.onOpen && this.options.onOpen();
  };
}

const crashWs = new WebsocketController();
const chatWs = new WebsocketController();
window.crashWs = crashWs;
window.chatWs = chatWs;
export { crashWs, chatWs };


// WEBPACK FOOTER //
// ./app/websocketController.js